exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ButtonsBlock__block{margin-top:8px}@media (max-width:500px){.ButtonsBlock__block{position:fixed;z-index:3;bottom:0;left:0;width:100%;padding:40px 20px 20px}.ButtonsBlock__block>a{display:none}.ButtonsBlock__block>button{width:100%;font-size:16px;height:52px}}", ""]);

// exports
exports.locals = {
	"block": "ButtonsBlock__block"
};